/*
 * @Description: 复选框
 * @Author: oubu
 * @Date: 2020-03-03
 */
import React from 'react';
import './index.less';
import Config from 'config/Config';

const CDN_BASE = Config.CDN_BASE || '';

const CheckBox = (props) => {
  const { checked, disabled, onClick, redStyle, icon, crossStyle } = props;
  let scr = '';
  if (disabled) {
    if (checked) {
      scr = CDN_BASE + '/assets/imgs/widget/CheckBox/icon-checked-disable.png';
    } else {
      scr = CDN_BASE + '/assets/imgs/widget/CheckBox/icon-unchecked-disable.png';
    }
  } else {
    if (checked) {
      scr = CDN_BASE + '/assets/imgs/widget/CheckBox/icon-checked.png';
      if (redStyle) {
        scr = '/assets/imgs/widget/CheckBox/icon-checked-copy.png';
      }
      if (crossStyle) {
        scr = '/assets/imgs/widget/CheckBox/icon-checked-cross.png';
      }
    } else {
      scr = CDN_BASE + '/assets/imgs/widget/CheckBox/icon-unchecked.png';
    }
  }

  return scr ? (
    <img
      src={scr}
      className="common-checkbox"
      disabled={disabled}
      checked={checked}
      onClick={(e) => {
        if (!disabled) {
          onClick && onClick(e);
        }
      }}
    />
  ) : (
    <span
      className={`iconfont icon-danxuankuangxuanzhong`}
      onClick={(e) => {
        console.log('点击的时候加载这个方法' + e);
        if (!disabled) {
          onClick && onClick(e);
        }
      }}
    />
  );
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/widget/CheckBox/index.js